import { LayoutDashboard } from 'lucide-react';
import type { NavItem } from './types';

/**
 * The top-level «Inicio» destination (§4.12), view 6: the dashboard. Its label
 * is «Inicio» and not «Dashboard» — the product speaks Spanish, and «Inicio» is
 * what the page is to whoever lands on it.
 *
 * `minimumPhase: 'in-certification'` = "it needs at least one registered
 * company". With none, the dashboard has nobody to measure, so the item carries
 * a lock and the reason; it is not hidden. Once a company exists but the SII
 * has not authorised it yet, the item opens: the index route (`HomePage`)
 * renders the locked dashboard at `/`, which says when it activates and links
 * to the certification (R2, C-1), so «Inicio» stays the highlighted item.
 */
export const dashboardNav: readonly NavItem[] = [
  {
    label: 'Inicio',
    to: '/',
    icon: LayoutDashboard,
    group: 'operation',
    minimumPhase: 'in-certification',
  },
];
